export const galleryConsts = {
        GET_GALLERY: "GET_GALLERY",
        UPDATE_GALLERY_IMAGE: "UPDATE_GALLERY_IMAGE",
        DELETE_IMAGE_BY_ID: "DELETE_IMAGE_BY_ID",
        UPLOAD_FILE: 'UPLOAD_FILE',
        ADD_FOLDER: 'ADD_FOLDER',
        DELETE_FOLDER: 'DELETE_FOLDER',
    };
